/** Kreul Live: Finanzierungs- und Zahlart-Ereignisse (Kevin 31.10.2026). Keine persönlichen Daten übergeben, nur Art + Produkt/Betrag. */
export function liveEvent(what, detail = "") {
  try { if (window.kmgLive) window.kmgLive(String(what).slice(0, 80), String(detail || "").slice(0, 120)); } catch (e) { /* egal */ }
}
